import { Utils } from 'versafleet-core';

const { request } = Utils.RequestHelper;

function receiveOurLocations(ourLocations) {
  return {
    type: 'RECEIVE_OUR_LOCATIONS',
    ourLocations,
  };
}

function fetchList() {
  return (dispatch) => {
    request('/my_locations/list', {
      method: 'GET',
    })
      .then((result) => {
        dispatch(receiveOurLocations(result.my_locations));
        return result;
      });
  };
}

export default {
  fetchList,
};
